@if (show()) {
  <div class="search-dropdown">
    @if (isLoading()) {
      <div class="search-dropdown__row search-dropdown__row--loading">
        <span>{{ 'messages.label.loading' | translate }}</span>
      </div>
    } @else if (results().length === 0) {
      <div class="search-dropdown__row search-dropdown__row--empty">
        <span>{{ 'search.no_results' | translate }}</span>
      </div>
    } @else {
      @for (result of results(); track result.id) {
        <div
          class="search-dropdown__row search-dropdown__row--result"
          (click)="onResultClick(result.id)"
          (keyup.enter)="onResultClick(result.id)"
          role="button"
          tabindex="0"
        >
          <div class="search-dropdown__result-top">
            <div class="search-dropdown__result-left">
              <span class="search-dropdown__document-name">{{ result.document_name }}</span>
            </div>
            <div class="search-dropdown__result-right">
              <tds-tag [accent]="getTypeAccent(result.type)" size="sm">
                {{ 'models.courrier.type.' + result.type | translate }}
              </tds-tag>
              <tds-tag [accent]="getStatusAccent(result.status)" size="sm">
                {{ 'models.courrier.status.' + result.status | translate }}
              </tds-tag>
              @if (result.send_date) {
                <span class="search-dropdown__date"
                  >{{ 'search.send_date_prefix' | translate }} {{ formatDateTime(result.send_date) }}</span
                >
              }
            </div>
          </div>
          @if (result.recipients.length) {
            <div class="search-dropdown__recipient">
              {{ 'models.courrier.recipient' | translate }}&nbsp;: {{ result.recipients[0].firstname }}
              {{ result.recipients[0].lastname }}
              @if (result.recipients.length > 1) {
                {{ 'models.courrier.more_count' | translate: { count: result.recipients.length - 1 } }}
              }
            </div>
          }
        </div>
      }
    }

    <div class="search-dropdown__footer" (click)="onSeeMore()" (keyup.enter)="onSeeMore()" role="button" tabindex="0">
      <span class="search-dropdown__footer-label">
        <tds-icon name="search" size="sm" />
        {{ 'search.more_results_prefix' | translate }} {{ getFooterTokensText() }}
      </span>
      <span class="search-dropdown__footer-enter">{{ 'search.enter_key' | translate }}</span>
    </div>
  </div>
}
